export enum DateFilters {
  ANYTIME = 'Anytime',
  LAST_HOUR = 'Last Hour',
  LAST_3_HOURS = 'Last 3 Hours',
  LAST_24_H = 'Last 24 Hours',
  LAST_72_H = 'Last 72 Hours',
  LAST_7_DAYS = 'Last 7 Days',
  LAST_MONTH = 'Last Month',
  CUSTOM_DATE = 'Custom Date'
}
